// "Request more credits": the app's Choose-an-option modal (ModalWrap + measurement-choice-modal),
// with two choices. Partner code -> Inochi signup; no partner code -> Contact us.
import React from "react";
import ModalWrap from "../modals/ModalWrap";
import "../modals/recorduploadchoice.scss";
import { openExternalUrl } from "../../utlis/webViewBridge";
import { URLS } from "./prodUsConfig";
import { pt } from "./prodUsStrings";

const ProdUsCreditsModal = ({ open, onClose }) => {
  const go = (url) => {
    openExternalUrl(url);
    onClose();
  };
  return (
    <ModalWrap
      open={open}
      onClose={onClose}
      className="record-upload-modal measurement-choice-modal"
    >
      <div className="record-upload-choice-wrapper">
        <p className="modal-title">{pt("rc_q_title")}</p>
        <p className="modal-subtitle">{pt("rc_q_sub")}</p>
        <div className="choice-buttons">
          <button
            type="button"
            className="choice-btn"
            onClick={() => go(URLS.partnerSignup)}
          >
            <div className="btn-content">
              <p className="btn-title">{pt("rc_q_yes")}</p>
              <p className="btn-description">{pt("rc_q_yes_desc")}</p>
            </div>
          </button>
          <button
            type="button"
            className="choice-btn"
            onClick={() => go(URLS.contact)}
          >
            <div className="btn-content">
              <p className="btn-title">{pt("rc_q_no")}</p>
              <p className="btn-description">{pt("rc_q_no_desc")}</p>
            </div>
          </button>
        </div>
        <button type="button" className="cancel-modal-btn" onClick={onClose}>
          {pt("cancel")}
        </button>
      </div>
    </ModalWrap>
  );
};

export default ProdUsCreditsModal;
